import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@digdir/designsystemet-react';

import { OppvarmingSol } from '../../../../../../types/registration/userInput';
import {
  AccentedTableRow,
  Capitalize,
  LeftBorderCell
} from '../../../../../expertRegistration/json/enhet/upload/fileReview/components/styledComponents';

interface OppvarmingSolfangerProps {
  solfanger: OppvarmingSol | undefined;
}
export const OppvarmingSolfangerView: FC<OppvarmingSolfangerProps> = ({ solfanger }) => {
  const { t } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary.tekniskutstyr.oppvarming.solfanger' });
  const { t: tCommon } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary.common' });

  return (
    solfanger && (
      <Fragment>
        <AccentedTableRow $isSecondarySection>
          <TableCell colSpan={2}>{t('header')}</TableCell>
        </AccentedTableRow>
        {solfanger.solceller && (
          <TableRow>
            <TableCell>{t('solceller')}</TableCell>
            <LeftBorderCell>{solfanger.solceller ? t('yes') : t('no')}</LeftBorderCell>
          </TableRow>
        )}

        {solfanger.solfangerMedVannbarenVarme && (
          <Fragment>
            <AccentedTableRow>
              <TableCell colSpan={2}>{t('varmesentral.label')}</TableCell>
            </AccentedTableRow>
            {solfanger.solfangerMedVannbarenVarme.installasjonsAr && (
              <TableRow>
                <TableCell>{t('varmesentral.installasjonsar')}</TableCell>
                <LeftBorderCell>{solfanger.solfangerMedVannbarenVarme.vetInstallasjonsAr ? solfanger.solfangerMedVannbarenVarme.installasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: solfanger.solfangerMedVannbarenVarme.installasjonsAr })}</LeftBorderCell>
              </TableRow>
            )}
            {solfanger.solfangerMedVannbarenVarme.bruk && (
              <TableRow>
                <TableCell>{t('varmesentral.bruk.label')}</TableCell>
                <LeftBorderCell>{t(`varmesentral.bruk.${solfanger.solfangerMedVannbarenVarme.bruk}`)}</LeftBorderCell>
              </TableRow>
            )}
            {solfanger.solfangerMedVannbarenVarme.gulvvarme && (
              <TableRow>
                <TableCell>{t('varmesentral.gulvvarme.label')}</TableCell>
                <LeftBorderCell>
                  {t(`varmesentral.gulvvarme.${solfanger.solfangerMedVannbarenVarme.gulvvarme}`)}
                </LeftBorderCell>
              </TableRow>
            )}
            {solfanger.solfangerMedVannbarenVarme.radiator && (
              <TableRow>
                <TableCell>{t('varmesentral.radiator.label')}</TableCell>
                <LeftBorderCell>{t(`varmesentral.radiator.${solfanger.solfangerMedVannbarenVarme.radiator}`)}</LeftBorderCell>
              </TableRow>
            )}
            {solfanger.solfangerMedVannbarenVarme.serviceGjennomfortSiste2Ar && (
              <TableRow>
                <TableCell>{t('varmesentral.serviceGjennomfortSiste2Ar')}</TableCell>
                <LeftBorderCell>
                  {t(`varmesentral.${solfanger.solfangerMedVannbarenVarme.serviceGjennomfortSiste2Ar}`)}
                </LeftBorderCell>
              </TableRow>
            )}
          </Fragment>
        )}

        {solfanger.solfangerMedVannbarenVarmeMedVarmesentral && (
          <Fragment>
            <AccentedTableRow>
              <TableCell colSpan={2}>{t('varmesentral.label')}</TableCell>
            </AccentedTableRow>
            {solfanger.solfangerMedVannbarenVarmeMedVarmesentral.installasjonsAr && (
              <TableRow>
                <TableCell>{t('varmesentral.installasjonsar')}</TableCell>
                <LeftBorderCell>{solfanger.solfangerMedVannbarenVarmeMedVarmesentral.vetInstallasjonsAr ? solfanger.solfangerMedVannbarenVarmeMedVarmesentral.installasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: solfanger.solfangerMedVannbarenVarmeMedVarmesentral.installasjonsAr })}</LeftBorderCell>
              </TableRow>
            )}
            {solfanger.solfangerMedVannbarenVarmeMedVarmesentral.bruk && (
              <TableRow>
                <TableCell>{t('varmesentral.bruk.label')}</TableCell>
                <LeftBorderCell>
                  {t(`varmesentral.bruk.${solfanger.solfangerMedVannbarenVarmeMedVarmesentral.bruk}`)}
                </LeftBorderCell>
              </TableRow>
            )}
            {solfanger.solfangerMedVannbarenVarmeMedVarmesentral.varmesystemBruk && (
              <TableRow>
                <TableCell>{t('varmesentral.varmesystembruk')}</TableCell>
                <LeftBorderCell><Capitalize>{solfanger.solfangerMedVannbarenVarmeMedVarmesentral.varmesystemBruk.trimStart()}</Capitalize></LeftBorderCell>
              </TableRow>
            )}
            {solfanger.solfangerMedVannbarenVarmeMedVarmesentral.gulvvarme && (
              <TableRow>
                <TableCell>{t('varmesentral.gulvvarme.label')}</TableCell>
                <LeftBorderCell>
                  {t(`varmesentral.gulvvarme.${solfanger.solfangerMedVannbarenVarmeMedVarmesentral.gulvvarme}`)}
                </LeftBorderCell>
              </TableRow>
            )}
            {solfanger.solfangerMedVannbarenVarmeMedVarmesentral.radiator && (
              <TableRow>
                <TableCell>{t('varmesentral.radiator.label')}</TableCell>
                <LeftBorderCell>
                  {t(`varmesentral.radiator.${solfanger.solfangerMedVannbarenVarmeMedVarmesentral.radiator}`)}
                </LeftBorderCell>
              </TableRow>
            )}
            {solfanger.solfangerMedVannbarenVarmeMedVarmesentral.varmesentral && (
              <TableRow>
                <TableCell>{t('varmesentral.varmesentral.label')}</TableCell>
                <LeftBorderCell>
                  {t(`varmesentral.varmesentral.${solfanger.solfangerMedVannbarenVarmeMedVarmesentral.varmesentral}`)}
                </LeftBorderCell>
              </TableRow>
            ) &&
              solfanger.solfangerMedVannbarenVarmeMedVarmesentral.varmesentralInstallasjonsAr && (
                <TableRow>
                  <TableCell>{t('varmesentral.varmesentral.varmesentralInstallasjonsAr')}</TableCell>
                  <LeftBorderCell>
                    {solfanger.solfangerMedVannbarenVarmeMedVarmesentral.vetVarmesentralInstallasjonsAr ? solfanger.solfangerMedVannbarenVarmeMedVarmesentral.varmesentralInstallasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: solfanger.solfangerMedVannbarenVarmeMedVarmesentral.varmesentralInstallasjonsAr })}
                  </LeftBorderCell>
                </TableRow>
              )}
            {solfanger.solfangerMedVannbarenVarmeMedVarmesentral.serviceGjennomfortSiste2Ar && (
              <TableRow>
                <TableCell>{t('varmesentral.serviceGjennomfortSiste2Ar')}</TableCell>
                <LeftBorderCell>
                  {t(`varmesentral.${solfanger.solfangerMedVannbarenVarmeMedVarmesentral.serviceGjennomfortSiste2Ar}`)}
                </LeftBorderCell>
              </TableRow>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  );
};
